import { useEffect } from "react";
import { preloadMatchCelebrationWhenIdle } from "./matchCelebrationPreload";

export function usePreloadMatchCelebration(): void {
  useEffect(() => {
    preloadMatchCelebrationWhenIdle();
  }, []);
}
